import clsx from 'clsx';
import { PencilIcon } from '../../../icons/pencilIcon';
import { Button } from '../../ui/Button';
import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogTrigger } from '../../ui/Modal';
import { ContractDialog } from './ContractDialog';
import { QuestionIcon } from '../../../icons/questionIcon';
import { IdInstructions } from './IdInstructions';
import { ApprovedCircled } from '../../../icons';
import { useLocation } from 'react-router-dom';

export const ContractSection = ({
  onStepCompleted,
  currentSubStep,
  documents,
  validateSigneeOptions,
  cncode,
}) => {

  const [openModal, setOpenModal] = useState(false);
  const [openInstructions, setOpenInstructions] = useState(false);
  
  const [error, setError] = useState(false)

  const location = useLocation();

  useEffect(() => {
      if (location && location.state) {
          if (location.state.status === 'failed') {
            setError(true)
          }
        }
  },[location])

  return (
    <div className="lg:left-[400px] pt-10 absolute top-0 w-full lg:w-[calc(100vw-500px)] max-lg:p-2 max-lg:pb-[150px]">
      <div className="flex border-b pb-2  border-b-[#A5A5A5] justify-between">
            <div className="flex gap-2 pl-4 items-center">
                <PencilIcon className="stroke-black" />
                <h4>Υπογραφή Συμβολαίων</h4>
            </div>
           <Button disabled={documents.findIndex(item=> item.status === 'unsigned') !== -1}
          onClick={onStepCompleted} className={'max-lg:hidden disabled:bg-[#A5A5A5] bg-[#D4002A] px-5 py-2.5 rounded-full text-white text-sm font-[600]'}>Επόμενο</Button>
        </div>
      <div className="py-10 px-2 lg:px-16 flex flex-col gap-4 lg:container lg:mx-auto">
        <h4 className="max-lg:hidden">Ταυτοποίηση Χρήστη</h4>
        {error &&
                        <div className="p-4 bg-[#FFD5D5] rounded-[12px]">
                            Προέκυψε σφάλμα κατά τη σύνδεσή σου στο Gov.gr, προσπάθησε ξανά.
                        </div>}
        <div className="bg-white rounded-[12px] max-lg:flex-col flex w-full justify-between p-4 lg:p-6 max-lg:border max-lg:border-[#A5A5A5] max-lg:rounded-[12px]">
          <div className="flex flex-col gap-3 lg:w-[50%] max-lg:mb-3">
            <div className='flex justify-between w-full'>
              <h4>Υποβολή ταυτότητας {validateSigneeOptions !== 'KYC' && '(2 όψεις)' }</h4>
              <div className="flex gap-2 items-center lg:hidden">
              <p className="text-body">Κατάσταση</p>
              <h6>{currentSubStep === 1 ? 'Ανενεργό' : 'Ενεργό'}</h6>
              <div
                className={clsx(
                  'h-[8px] w-[8px] rounded-full',
                  currentSubStep === 1 ? 'bg-[#A5A5A5]' : 'bg-[#13EF00]'
                )}
              />
            </div>
            </div> 
            {validateSigneeOptions === 'KYC' ?<p className="text-disclaimer">
              Επίλεξε «Σύνδεση» για να βεβαιώσεις τα στοιχεία της ταυτότητάς σου μέσω eGov-KYC.
            </p>: <p className="text-disclaimer">Επίλεξε «Υποβολή» για να ανεβάσεις την ταυτότητά σου.</p>}
          </div>
          <div className="gap-3 flex flex-col justify-between ">
            <div className="flex gap-2 items-center max-lg:hidden">
              <p className="text-body">Κατάσταση</p>
              <h6>{currentSubStep === 1 ? 'Ανενεργό' : 'Ενεργό'}</h6>
              <div
                className={clsx(
                  'h-[8px] w-[8px] rounded-full',
                  currentSubStep === 1 ? 'bg-[#A5A5A5]' : 'bg-[#13EF00]'
                )}
              />
            </div>
            {validateSigneeOptions === 'Regula' ? 
            <div className="flex gap-2">
              <Dialog
                open={openInstructions}
                onOpenChange={(open) => setOpenInstructions(open)}
              >
                <DialogTrigger>
                  <QuestionIcon className={'cursor-pointer'} />
                </DialogTrigger>
                <DialogContent className={'max-lg:h-full'}>
                  <IdInstructions />
                </DialogContent>
              </Dialog>
              <Dialog
                open={openModal}
                onOpenChange={(open) => setOpenModal(open)}
              >
                <DialogTrigger className='max-lg:w-full'>
                  <Button
                    disabled={currentSubStep !== 1}
                    className={
                      'rounded-[6px] border border-[#A5A5A5] px-12 py-3 font-[600] h5 disabled:opacity-70 max-lg:w-full'
                    }
                  >
                    Υποβολή
                  </Button>
                </DialogTrigger>
                <DialogContent  className={'max-lg:h-full'}>
                  <ContractDialog />
                </DialogContent>
              </Dialog>
              </div>
              : currentSubStep === 1 && <Button onClick={() => {
                window.open(`${process.env.REACT_APP_KYC_URL}/oauth?response_type=code&state=${cncode}&client_id=${process.env.REACT_APP_KYC_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_BASE_URL}/KYC/callback&lang=el&scope=identity%20income%20contactInfo%20professionalActivity`,"_self")
              }} className="lg:justify-center max-lg:justify-center flex rounded-[6px] border border-[#A5A5A5] items-center px-4 py-1font-[600] text-body disabled:opacity-70 max-lg:w-full">
                <img width={40} height={40} alt="" src="/avis/images/govIcon.png" className={'stroke-black'}/>
                Σύνδεση
              </Button>}
          </div>
        </div>
        <p className="font-[700] text-[18px]">Ηλεκτρονική Υπογραφή</p>
        <p className="text-disclaimer">Ως επιπλέον βήμα επαλήθευσης για κάθε υπογραφή, θα λάβεις κωδικό μίας χρήσης στον αριθμό κινητού που έχεις δηλώσει.</p>
        {documents.map(item => 
         <div className="bg-white max-lg:flex-col rounded-[12px] flex w-full lg:justify-between p-4 lg:p-6 lg:items-center max-lg:border max-lg:border-[#A5A5A5] max-lg:rounded-[12px]">
         <div className="flex max-lg:mb-3 flex-col gap-3 lg:w-[50%]">
            <p className="font-[700] text-[18px]">{item.type}</p>
        
          </div>
            <Dialog>
              <DialogTrigger onOpenChange={(open) => { if (!open)  window.location.reload();} }  disabled={currentSubStep !== 2 || item.status !== 'unsigned' }
                className={
                  'cursor-pointer h-fit text-body rounded-[6px] py-3 border border-[#A5A5A5] w-[167px] h5 disabled:opacity-70 max-lg:w-full'
                }>
              <div>
              {item.status === 'unsigned' ? 'Υπογραφή' :
                <div className='flex gap-2 items-center w-full justify-center max-lg:w-full'>
                  <ApprovedCircled className={'h-3 w-3'} />
                  Υπογεγραμμένο
                </div>
              }
              </div>
              </DialogTrigger>
              <DialogContent className="p-6 h-[80%]">
                <iframe
                  title={item.type}
                  src={item.link}
                  border={0}
                  width={"100%"}
                  height={'100%'}
              />
              </DialogContent>
            </Dialog>
       </div>
        )}
      </div>
      <Button  disabled={documents.findIndex(item=> item.status === 'unsigned') !== -1}
          onClick={onStepCompleted} className={'lg:hidden disabled:bg-[#A5A5A5] bg-[#D4002A] px-5 py-2.5 mt-4 rounded-[6px] text-white text-sm font-[600] w-full'}>Επόμενο</Button>    

    </div>
  );
};
